import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';

import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import {
  CreateDerogatoryRegimeParams,
  DerogatoryRegime,
  ListDerogatoryRegimeRequestParams,
  UpdateDerogatoryRegimeParams
} from '~core/models/derogatory-regime.models';

@Injectable()
export class DerogatoryRegimeService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  private _buildUrl(taxExemptionTypeId: string, id?: string): string {
    const baseUrl = `${this._apiConstantsService.taxExemptionTypeUrl}/${taxExemptionTypeId}/derogatory-regimes`;
    return id ? `${baseUrl}/${id}` : baseUrl;
  }

  list(
    taxExemptionTypeId: string,
    params?: ListDerogatoryRegimeRequestParams
  ): Observable<Pagination<DerogatoryRegime>> {
    return this._http.get<Pagination<DerogatoryRegime>>(
      this._buildUrl(taxExemptionTypeId),
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(taxExemptionTypeId: string, id: string): Observable<DerogatoryRegime> {
    return this._http.get<DerogatoryRegime>(
      this._buildUrl(taxExemptionTypeId, id)
    );
  }

  create(
    taxExemptionTypeId: string,
    payload: CreateDerogatoryRegimeParams
  ): Observable<DerogatoryRegime> {
    return this._http.post<DerogatoryRegime>(
      this._buildUrl(taxExemptionTypeId),
      payload
    );
  }

  update(
    taxExemptionTypeId: string,
    id: string,
    payload: UpdateDerogatoryRegimeParams
  ): Observable<DerogatoryRegime> {
    return this._http.patch<DerogatoryRegime>(
      this._buildUrl(taxExemptionTypeId, id),
      payload
    );
  }

  delete(taxExemptionTypeId: string, id: string): Observable<unknown> {
    return this._http.delete(this._buildUrl(taxExemptionTypeId, id));
  }
}
